import httpManager from "@/app/shared/utils/httpManager";

export default async function (userId, filters) {
  const { entity, portfolio, startDate, endDate, queue } = filters;

  let url = `/dashboard/resume-schedules/excel/?user=${userId}&date_start=${startDate}&date_end=${endDate}&`;

  if (entity !== undefined) url += `entity=${entity ?? ""}&`;
  if (portfolio) url += `portfolio=${portfolio}&`;
  if (queue) url += `queue=${queue}&`;

  const response = await httpManager.getBlob(url);
  return response;
}
